import { createFileRoute } from '@tanstack/react-router'
import { StoresTab } from '~/components/routes/visioReviews/StoresTab'
import { VisioReviewsLayout } from '~/components/routes/visioReviews/VisioReviewsLayout'
import {
  useVisioReviewsPeriod,
  visioReviewsSearchSchema,
} from '~/components/routes/visioReviews/search'
import { VISIO_REVIEWS_TAB_PERMISSIONS } from '~/components/routes/visioReviews/tabs'
import { withRoutePermissions } from '~/utils/rbac'

export const Route = createFileRoute('/_authenticated/visio-reviews/boutique')({
  staticData: {
    permission: VISIO_REVIEWS_TAB_PERMISSIONS.boutique,
  },
  validateSearch: visioReviewsSearchSchema,
  component: VisioReviewsBoutiquePage,
})
withRoutePermissions(Route)

function VisioReviewsBoutiquePage() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()
  const { dateRange, previousPeriod } = useVisioReviewsPeriod(search)

  return (
    <VisioReviewsLayout
      activeTab="boutique"
      search={search}
      onSearchChange={(next) => navigate({ search: next })}
    >
      <StoresTab dateRange={dateRange} previousPeriod={previousPeriod} />
    </VisioReviewsLayout>
  )
}
